module.exports = __webpack_public_path__ + "static/media/shodan-logo.c755bd15.png";